import * as Yup from 'yup'
import { isNil } from 'ramda'

import { emailRegExpFormat } from 'commons/email'
import { validatePhoneNumber } from 'app/componentV4/Input/PhoneNumberInputV4'

export const validationSchema = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'error.form.required',
  })
  return Yup.object({
    firstName: Yup.string()
      .matches(
        /^[^\d]/,
        formatMessage(
          {
            id: 'validation.notStartNumber',
          },
          {
            filedName: formatMessage({
              id: 'firstName.label',
            }),
          },
        ),
      )
      .required(textRequired),
    lastName: Yup.string()
      .matches(
        /^[^\d]/,
        formatMessage(
          {
            id: 'validation.notStartNumber',
          },
          {
            filedName: formatMessage({
              id: 'lastName.label',
            }),
          },
        ),
      )
      .required(textRequired),
    languageId: Yup.object().required(textRequired),
    roles: Yup.array()
      .of(Yup.number().typeError('Roles must be a number'))
      .min(1, textRequired)
      .required(textRequired),
    email: Yup.string()
      .transform((value) => value.trim())
      .matches(
        emailRegExpFormat,
        formatMessage({
          id: 'memberForm.emailInvalid',
        }),
      )
      .required(textRequired),
    countryCode: Yup.string(),
    phoneNumber: Yup.string().test(
      'is-valid-phone',
      formatMessage({ id: 'crm.form.validation.url' }),
      (value) => {
        if (isNil(value)) return true
        return validatePhoneNumber(value)
      },
    ),
  })
}
